import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import BaseModal from "../BaseModal/BaseModal";
import styles from "./BoardLimitModal.module.css";
import { upgradePlanAndCreateBoard, upgradePlanAndUpdateBoardStatus } from "../../api/boards";

function BoardLimitModal({
  open,
  onClose,
  currentPrice,
  nextBoardPrice,
  companySlug,
  newPlanLimit,
  pendingAction,
  onDone,
}) {
  console.log("BoardLimitModal pendingAction:", pendingAction);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleAgree = async () => {
    if (!companySlug || !newPlanLimit) return;

    setError("");
    setIsSubmitting(true);

    try {
      const actionType = pendingAction?.type || "create_board";

      if (actionType === "create_board") {
        const data = await upgradePlanAndCreateBoard(companySlug, newPlanLimit);
        onClose?.();
        onDone?.();
        navigate(`/board/${data.company_slug}/${data.dashboard_slug}/edit`);
        return;
      }

      if (actionType === "update_board_status") {
        const boardId = pendingAction?.boardId;
        const newStatus = pendingAction?.newStatus;

        if (!boardId || newStatus !== "active") {
          throw new Error(t('board_limit.bad_data_error'));
        }

        await upgradePlanAndUpdateBoardStatus(companySlug, newPlanLimit, boardId);
        onClose?.();
        onDone?.();
        return;
      }

      throw new Error(t('board_limit.upgrade_error'));
    } catch (e) {
      console.error(e);
      setError(e.message || t('board_limit.upgrade_error'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const title =
    pendingAction?.type === "update_board_status"
      ? t('board_limit.activate_title')
      : t('board_limit.create_title');

  return (
    <BaseModal open={open} onClose={onClose} scrollable={true}>
      <p className={styles.modalTitle}>{title}</p>

      <p className={styles.modalText}>
        {t('board_limit.description')}
      </p>

      <div className={styles.boardsContainer}>
        <p className={styles.tariffTitle} dangerouslySetInnerHTML={{ __html: t('board_limit.current_price', { price: currentPrice }) }} />
        <p className={styles.tariffTitle} dangerouslySetInnerHTML={{ __html: t('board_limit.next_price', { price: nextBoardPrice }) }} />

        <p className={styles.tariffText}>
          {t('board_limit.pricing_info')}{" "}
          <Link to="/pricing">{t('board_limit.details_link')}</Link>
        </p>

        {error && <p style={{ color: "red", marginTop: 8 }}>{error}</p>}

        <div className={styles.buttons}>
          <div
            className={`button primary-button ${isSubmitting ? styles.disabled : ""}`}
            onClick={isSubmitting ? undefined : handleAgree}
            role="button"
            aria-disabled={isSubmitting}
          >
            {isSubmitting ? t('board_limit.processing') : t('board_limit.confirm')}
          </div>

          <div className="button cancelButton" onClick={onClose}>
            {t('common.cancel_short')}
          </div>
        </div>
      </div>
    </BaseModal>
  );
}

export default BoardLimitModal;
